import React from 'react';
import { Icon } from 'semantic-ui-react';
import Popover from './Popover';
import {
  AdvancedBody,
  AdvancedCloseButton,
  AdvancedFooter,
  AdvancedHeader,
  AdvancedTitle,
  FieldGroup,
  FieldLabel,
  OutlineButton,
  PrimaryButton
} from './styles';
import { FilterField, FilterFieldContext, FilterValues } from './types';
import FilterFieldRenderer from './FilterFieldRenderer';

export type AdvancedFiltersPopoverProps = {
  open: boolean;
  onClose: () => void;
  anchorRef: React.RefObject<HTMLElement>;
  fields: FilterField[];
  values: FilterValues;
  setValue: (name: string, value: any) => void;
  onClear: () => void;
  onApply: () => void;
  loading?: boolean;
};

const AdvancedFiltersPopover: React.FC<AdvancedFiltersPopoverProps> = ({
  open,
  onClose,
  anchorRef,
  fields,
  values,
  setValue,
  onClear,
  onApply,
  loading
}) => {
  const ctx: FilterFieldContext = {
    values,
    setValue,
    loading
  };

  return (
    <Popover open={open} onClose={onClose} anchorRef={anchorRef} width={360} align="right">
      <AdvancedHeader>
        <AdvancedTitle>
          <Icon name="sliders horizontal" />
          Filtros avançados
        </AdvancedTitle>
        <AdvancedCloseButton type="button" aria-label="Fechar" onClick={onClose}>
          <Icon name="close" />
        </AdvancedCloseButton>
      </AdvancedHeader>

      <AdvancedBody>
        {fields.map(field => (
          <FieldGroup key={field.name} flex={1} minWidth={0}>
            {field.kind !== 'checkbox' && field.kind !== 'custom' && (
              <FieldLabel>{field.label}</FieldLabel>
            )}
            <FilterFieldRenderer
              field={field}
              ctx={ctx}
              onSearch={onApply}
              inOverlay
            />
          </FieldGroup>
        ))}
      </AdvancedBody>

      <AdvancedFooter>
        <OutlineButton type="button" onClick={onClear}>
          Limpar
        </OutlineButton>
        <PrimaryButton
          type="button"
          onClick={() => {
            onApply();
            onClose();
          }}
        >
          Aplicar
        </PrimaryButton>
      </AdvancedFooter>
    </Popover>
  );
};

export default AdvancedFiltersPopover;
